$(document).ready(function () {
    // Initially hide all images
    $('.image').hide();
    $(document).on("mouseover", ".imagebtn", function () {
        var tabID = $(this).attr('data-tab');
        $('.image' + tabID).fadeIn(); // Fade in smoothly
    });
    $(document).on("mouseout", ".imagebtn", function () {
        var tabID = $(this).attr('data-tab');
        $('.image' + tabID).fadeOut(); // Fade out smoothly
    });
});
